import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

@Component({
  name: 'bpc-drawer-modal',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class DrawerModal extends Vue {
  /**
   * SLOTS
   * top-left-buttons
   * top-right-buttons
   */

  @Prop({ type: String }) readonly entity: string;

  // TODO this permissionEntityName property should be removed
  // Check the comment in canManageEntity computed property
  @Prop({ type: String }) readonly permissionEntityName: string;
  @Prop({ type: Boolean, default: false }) readonly showDrawer: boolean;
  @Prop({ type: Boolean, default: false }) readonly showExpandButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showSaveButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showIconSaveButton: boolean;
  @Prop({ type: Boolean, default: false }) readonly saveButtonDisabled: boolean;
  @Prop({ type: Boolean, default: false }) readonly showSaveNewButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showIconSaveNewButton: boolean;
  @Prop({ type: Boolean, default: false }) readonly saveNewButtonDisabled: boolean;
  @Prop({ type: Boolean, default: true }) readonly showCancelButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showIconCancelButton: boolean;
  @Prop({ type: Boolean, default: false }) readonly isSaving: boolean;
  @Prop({ type: Boolean, default: true }) readonly showTitle: boolean;
  @Prop({ type: String, default: '' }) readonly title: string;
  @Prop({ type: String, default: 'global.buttons.save' }) readonly labelSaveButton: string;
  @Prop({ type: String, default: 'global.buttons.saving' }) readonly labelSavingButton: string;
  @Prop({ type: String, default: 'global.buttons.save_and_new' })
  readonly labelSaveNewButton: string;
  @Prop({ type: String, default: 'global.buttons.cancel' }) readonly labelCancelButton: string;
  @Prop({ type: String, default: 'global.buttons.edit' }) readonly labelEditButton: string;
  @Prop({ type: String, default: 'times' }) readonly iconCancelButton: string;
  @Prop({ type: String, default: 'save' }) readonly iconSaveButton: string;
  @Prop({ type: String, default: 'save' }) readonly iconSaveNewButton: string;
  @Prop({ type: String, default: 'success' }) readonly variantSaveButton: string;
  @Prop({ type: Number }) readonly numberOfButtonCols: number;
  @Prop({ type: String, default: 'md' }) readonly size: string;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop({ type: Boolean, default: true }) readonly showEditButton: boolean;

  get classSizeObject(): object {
    return {
      'drawer-modal-size--sm': this.size === 'sm',
      'drawer-modal-size--md': this.size === 'md',
      'drawer-modal-size--lg': this.size === 'lg',
      'drawer-modal-size--xl': this.size === 'xl',
    };
  }

  showDrawerExpanded: boolean = false;

  onClickSave() {
    this.$emit('click-on-save');
  }

  onClickClose() {
    this.$emit('click-on-close');
  }

  onClickCancel() {
    this.$emit('click-on-cancel');
  }

  onClickSaveAndNew() {
    this.$emit('click-on-save-and-new');
  }

  onClickExpand() {
    this.showDrawerExpanded = !this.showDrawerExpanded;
  }
  onClickEdit() {
    this.$emit('click-on-edit');
  }

  // TODO this logic should be outside of the drawer
  // And simply pass the showEditButton from outside
  get canManageEntity(): boolean {
    const entity = this.permissionEntityName?.replace('-', '_');
    return (
      this.permissionEntityName &&
      this.$authorizationService.hasPermissions([`manage_${entity}`, `manage_own_${entity}`])
    );
  }
}
